<div class="avatar size-{{ size }}">
  <div *ngIf="!image" class="noAvatar">
    <div class="centerCircle"></div>
    <div class="bottomCircle"></div>
  </div>
  <div *ngIf="image" class="image">
    <img [src]="image" alt="Avatar" />
  </div>
</div>
